import { render, staticRenderFns } from "./Collapsible.vue?vue&type=template&id=459d8145"
import script from "./Collapsible.vue?vue&type=script&lang=js"
export * from "./Collapsible.vue?vue&type=script&lang=js"
import style0 from "./Collapsible.vue?vue&type=style&index=0&id=459d8145&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports